import { queryKeys } from '@sshop/api-client';

import { api } from '@/shared/lib/apiClient';
import { defineQuery } from '@/shared/lib/queryFactory';
import { routeLocale } from '@/shared/lib/routeLocale';

export const productFiltersQuery = (categorySlug?: string, search?: string, promotionId?: string) =>
  defineQuery({
    queryKey: queryKeys.product.filters(categorySlug, search, routeLocale(), promotionId),
    queryFn: ({ signal }) =>
      api.products.filters(
        {
          ...(categorySlug ? { categorySlug } : {}),
          ...(search ? { search } : {}),
          ...(promotionId ? { promotionId } : {}),
        },
        signal,
      ),
    staleTime: 5 * 60_000,
  });
